import { render, staticRenderFns } from "./SavedMessage.vue?vue&type=template&id=306383e1&"
import script from "./SavedMessage.vue?vue&type=script&lang=js&"
export * from "./SavedMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports